import { useDispatch } from "react-redux";
import type { ThunkDispatchType } from "src/app/reducers/IMainAppState";
import { useQuery } from "react-query";
import {
  GetMerchantGroupByMerchantGroupUUID,
  GetMerchantGroups,
} from "src/merchantgroups/actions/MerchantGroupActionCreators";
import type { UseQueryOptions } from "react-query/types/react/types";
import type MerchantGroup from "src/merchantgroups/objects/MerchantGroup";

export const useMerchantGroups = (
  options?: UseQueryOptions<
    MerchantGroup[],
    unknown,
    MerchantGroup[],
    "merchantGroups"
  >,
) => {
  const dispatch = useDispatch<ThunkDispatchType>();
  return useQuery(
    "merchantGroups",
    async () => {
      return await dispatch(GetMerchantGroups());
    },
    options,
  );
};

export const useMerchantGroup = (
  merchantGroupUuid: string,
  options?: UseQueryOptions<MerchantGroup, unknown, MerchantGroup, string[]>,
) => {
  const dispatch = useDispatch<ThunkDispatchType>();
  return useQuery(
    ["merchantGroup", merchantGroupUuid],
    async () => {
      return await dispatch(
        GetMerchantGroupByMerchantGroupUUID(merchantGroupUuid),
      );
    },
    options,
  );
};
